import Swiper, { Pagination, Navigation} from 'swiper';
Swiper.use([ Pagination, Navigation]);

const swiperBorder = new Swiper('.slider-brand .swiper', {
	slidesPerView: 1,
	spaceBetween: 10,
	paginationClickable: true,
	pagination: {
		el: '.federation__brandbook .swiper-pagination',
		type: 'bullets',
	},
	breakpoints: {
		1025: {
			pagination: {
				el: '.federation__brandbook .swiper-pagination',
				type: 'fraction',
				clickable: true,
				formatFractionCurrent: function (number) {
					return number < 10 ? `0${number}` : number;
				},
				formatFractionTotal: function (number) {
					return number < 10 ? `0${number}` : number;
				},
			},
		},
	},
	navigation: {
		nextEl: '[data-slider-next]',
		prevEl: '[data-slider-prev]',
	},
});
